export interface IFetchStatus {
  fetching: boolean;
  fetched: boolean;
  success: boolean;
}

export const combineFetchStatus = (fetchStatuses: IFetchStatus[]) =>
  fetchStatuses.reduce((p, c) => ({
    fetching: c.fetching || p.fetching,
    fetched: c.fetched && p.fetched,
    success: c.success && p.success,
  }));

export const createDefaultFetch = (): IFetchStatus => ({
  fetching: false,
  fetched: false,
  success: false,
});

export const createFetchInProgress = (): IFetchStatus => ({
  fetching: true,
  fetched: false,
  success: false,
});

export const createFetchedWithError = (): IFetchStatus => ({
  fetching: false,
  fetched: true,
  success: false,
});

export const createFetchedSuccess = (): IFetchStatus => ({
  fetching: false,
  fetched: true,
  success: true,
});
